import useSWR from "swr";
import { useCreateProductServiceAdminAxiosInstance } from "../../Auth/useCreateProductServiceAdminAxiosInstance.ts";
import { BonificoOrderDTO, BonificoOrderStatus } from "./BonificoOrderDTO.ts";

const MAX_DRAFTS_LOOKED_UP = 20;

function isDraftOfCustomer(
  draft: BonificoOrderDTO,
  customerEmail: string,
): boolean {
  return (
    draft.status === BonificoOrderStatus.Draft &&
    draft.customer.email.trim().toLowerCase() ===
      customerEmail.trim().toLowerCase()
  );
}

export function useCustomerBonificoDrafts(customerEmail: string) {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const { data, error, isLoading } = useSWR(
    ["/bonifico-orders/customer-drafts", customerEmail],
    async () => {
      const { data } = await createAxiosInstance().get<{
        orders: BonificoOrderDTO[];
      }>("/bonifico-orders", {
        params: {
          search: customerEmail,
          status: BonificoOrderStatus.Draft,
          sortBy: "createdAt",
          sortDirection: "desc",
          pageSize: MAX_DRAFTS_LOOKED_UP,
        },
      });
      return data.orders.filter((order) =>
        isDraftOfCustomer(order, customerEmail),
      );
    },
    { revalidateOnFocus: false },
  );

  return { drafts: data ?? [], error, isLoading };
}
